import { DEV_TG_BOT_LINK, PROD_TG_BOT_LINK } from '@/shared/constants';
import { isDev } from '@/shared/helpers';
import { base64Utils } from '@/shared/helpers/base64-utils';

export const generateButtonUrl = (params: Record<string, any>): string => {
  const marketUrl = isDev('replyBot') ? DEV_TG_BOT_LINK : PROD_TG_BOT_LINK;

  const buttonUrl = `${marketUrl}/market?startapp=` + base64Utils.encode(params);

  return buttonUrl;
};
